module.exports = __webpack_public_path__ + "static/img/台邦商旅.b21d04f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/台邦商旅.png?20181011
// module id = t/c2
// module chunks = 1